import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared/models/api-response';
import { Observable } from 'rxjs';
import { global } from './global';
import { updateUser } from './user.service.types';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public url: string;
  public identity: any;
  public token: any;

  constructor(public _http: HttpClient) {
    this.url = global.url;
  }

  register(user: any): Observable<any> {
    const json = JSON.stringify(user);
    const params = 'json=' + json;

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this._http.post(this.url + 'register', params, {
      headers: headers,
    });
  }

  signup(user: any, gettoken: boolean | null = null): Observable<any> {
    if (gettoken != null) {
      user.gettoken = 'true';
    }
    const json = JSON.stringify(user);
    const params = 'json=' + json;

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this._http.post(this.url + 'login', params, {
      headers: headers,
    });
  }

  update(token: string, user: any): Observable<any> {
    const json = JSON.stringify(user);
    const params = 'json=' + json;

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', token);

    return this._http.put(this.url + 'user/update', params, {
      headers: headers,
    });
  }

  update_user(token: string, user: updateUser, id: number | null): Observable<any> {
    const json = JSON.stringify(user);
    const params = 'json=' + json;

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', token);

    return this._http.put(this.url + 'user/editar/' + id, params, {
      headers: headers,
    });
  }

  showUsuario(id: number): Observable<any> {
    return this._http.get(this.url + 'user/detail/' + id);
  }

  showUsuarioDetalle(id: number): Observable<any> {
    return this._http.get(this.url + 'user/usuario-detalle/' + id);
  }

  showUsuarioDetalleByCode(code: any): Observable<any> {
    return this._http.get(this.url + 'user/usuario-detalle-by-code/' + code);
  }

  getListaUsuarios(): Observable<any> {
    return this._http.get(this.url + 'user/user-list-all');
  }

  getUsuarioAdmin(): Observable<any> {
    return this._http.get(this.url + 'user/usuario-admin');
  }

  getUsuarioCliente(): Observable<any> {
    return this._http.get(this.url + 'user/usuario-cliente');
  }

  getIdentity() {
    const local = localStorage.getItem('identity');
    const identity = JSON.parse(local ? local : '');

    if (identity && identity != 'undefined') {
      this.identity = identity;
    } else {
      this.identity = null;
    }
    return this.identity;
  }

  getToken() {
    const token = localStorage.getItem('token');

    if (token && token != 'undefined') {
      this.token = token;
    } else {
      this.token = null;
    }

    return this.token;
  }

  checkToken(token: string): Observable<ApiResponse> {
    const obj = { token: token };
    const json = JSON.stringify(obj);
    const params = 'json=' + json;

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this._http.post<ApiResponse>(this.url + 'user/check-token', params, {
      headers: headers,
    });
  }

  changePassword(body: any): Observable<ApiResponse> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this._http.put<ApiResponse>(`${this.url}v1/admin-services/users/change-password`, body, {
      headers: headers,
    });
  }

  uploadImage(file: File) {
    const formData = new FormData();
    formData.append('file0', file);
    const headers = new HttpHeaders().set('Authorization', this.getToken());
    return this._http.post<{ status: string; image: string; code: number }>(global.url + 'user/upload', formData, { headers });
  }
}
